<template>
    <div class="c-text-glitch">
        <div class="c-text-glitch__item glitch" :data-text="text" >{{ text }}</div>
    </div>
</template>

<script>
    export default {
        name: 'GlitchText', 

        props: [
            'text'
        ],
    }
</script>

<style lang="scss" scoped>
    @import "../styles/imports";

    @keyframes scroll_horizontal_text {
        from { transform: translateX(0); }
        to { transform: translateX(-100%); }
    }

    .c-text-glitch {
        position:relative;
        margin: 0 auto;
        text-align:center;
        width:auto;  
        z-index: 30; 
        pointer-events: none;
        &__item {
            color:white; 
            font-family: $roboto; 
            font-weight:400;
            font-size: 0.875rem; 
            text-transform: uppercase;
            line-height:1;
            white-space: nowrap;
            letter-spacing: 3px;
        }
    }

    $color-white: hsla(0, 0%, 100%, 1);
    $color-black: rgba(0, 0, 0, 0.25);


    .c-text-glitch__item {
        position:relative;
        overflow: hidden;
        display:inline-block;
        white-space:nowrap;

        &::before,
        &::after {
            animation: glitch-anime 0s infinite linear alternate-reverse;
            color: $color-white;
            background:$color-black;
            content:attr(data-text);
            position: absolute;
            overflow:hidden;
            top: 0;
        }

        &::before {
            animation-duration: 4s;
            left:2px;
            text-shadow: 1px 0 $color-white;
        }

        &::after {
            animation-duration: 10s;
            left:0;
            text-shadow: -1px 0 $color-white;
        }
    }

    @keyframes glitch-anime {
    0%, 25%, 100% { 
            clip-path: polygon(0 2%, 100% 2%, 100% 5%, 0 5%);
        }
    
        5% {
            clip-path: polygon(0 15%, 100% 15%, 100% 15%, 0 15%);
        }
    
        7% {
            clip-path: polygon(0 10%, 100% 10%, 100% 20%, 0 20%);
        }
    
        10% {
            clip-path: polygon(0 1%, 100% 1%, 100% 2%, 0 2%);
        }
    
        12% {
            clip-path: polygon(0 33%, 100% 33%, 100% 33%, 0 33%);
        }
    
        13% {
            clip-path: polygon(0 44%, 100% 44%, 100% 44%, 0 44%);
        }
    
        15% {
            clip-path: polygon(0 50%, 100% 50%, 100% 20%, 0 20%);
        }

        16% {

            clip-path: polygon(0 70%, 100% 70%, 100% 70%, 0 70%);
        }

        17% {

            clip-path: polygon(0 80%, 100% 80%, 100% 80%, 0 80%);
        }

        20% {
            clip-path: polygon(0 50%, 100% 50%, 100% 55%, 0 55%);
        }

        21% {
            clip-path: polygon(0 60%, 100% 60%, 100% 65%, 0 65%);
        }

        23% {
            clip-path: polygon(0 72%, 100% 72%, 100% 78%, 0 78%);
        }
    }


    @media (prefers-reduced-motion: reduce) {
        .c-text-glitch__item {animation: none;}
    }

    @media all and (min-width:$small-breakpoint){
        .c-text-glitch{
            position:fixed;
            bottom: 48px; 
            right: 48px;             
        }
    }

</style>